require('dom-slider');

const { slideToggle, slideUp } = window.domSlider;

const readMoreButtons = document.querySelectorAll('.js-read-more-break');

const toggleContent = (e, ele) => {
	let element;

	if (e) {
		e.preventDefault();
		element = e.currentTarget;
	} else {
		element = ele;
	}

	element.classList.toggle('active');

	if (element.classList.contains('active')) {
		element.innerHTML = element.getAttribute('data-text-open');
	} else {
		element.innerHTML = element.getAttribute('data-text-closed');
	}

	const hiddenContent = element.previousElementSibling;

	slideToggle({
		element: hiddenContent,
		slideSpeed: 400,
		easing: 'ease-in-out',
		visibleDisplayValue: 'grid',
	});
};

const nextAll = (element) => {
	const siblings = [];
	let sibling = element.nextSibling;
	while (sibling) {
		if (sibling.nodeType === 1) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling;
	}
	return siblings;
};

const readMore = () => {
	if (readMoreButtons.length) {
		readMoreButtons.forEach((readMoreButton) => {
			const readMoreParentContainer = readMoreButton.parentNode;
			const readMoreContainer = readMoreParentContainer.querySelector(
				'.block-read-more-content'
			);
			readMoreButton.addEventListener('click', toggleContent);

			const hiddenContent = nextAll(readMoreButton);

			if (hiddenContent.length) {
				hiddenContent.forEach((content) => {
					readMoreContainer.append(content);
				});

				slideUp({
					element: readMoreContainer,
					slideSpeed: 0,
				});
			}

			if (readMoreContainer.classList.contains('is-style-open')) {
				toggleContent(null, readMoreButton);
			}
		});
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		readMore();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
